export function setZoomLevel(zoomLevel) {
  return {
    type: 'SET_ZOOM_LEVEL',
    zoomLevel
  }
}

export function setTerminalPlannerExpanded(expanded) {
  return {
    type: 'SET_TERMINAL_PLANNER_EXPANDED',
    expanded
  }
}

export function setMenuDropdownExpanded(expanded) {
  return {
    type: 'SET_MENU_DROPDOWN_EXPANDED',
    expanded
  }
}

export function setScrollBarWidth(scrollBarWidth) {
  return {
    type: 'SET_SCROLL_BAR_WIDTH',
    scrollBarWidth
  }
}
